const features = [
  {
    icon: 'ri-movie-line',
    title: '海量高清片库',
    desc: '10万+电影资源持续扩充，从好莱坞大片到小众佳作，经典老片与新片速递一网打尽，满足你的各种观影口味。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅播放',
    desc: '智能CDN加速技术，1080P超清画质在线播放不缓冲，多线路智能切换确保观影体验始终稳定流畅。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台无缝观影',
    desc: '电脑、平板、手机多端同步，收藏与播放记录云端同步，随时随地打开六六影院即可继续上次的观影进度。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择六六影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            三大核心优势，打造极致的免费在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-50 rounded-2xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}